import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-creation-grid',
  templateUrl: './member-creation-grid.component.html',
  styleUrls: ['./member-creation-grid.component.css']
})
export class MemberCreationGridComponent implements OnInit {
  title="MemberCreationList"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/member-creation-grid/member-creation-grid.component.ts